<div class="main-div">
  Chargement...
</div>
